import React from 'react';

const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/971542119784"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        background: '#2BAA5E',
        color: '#FCFDFE',
        borderRadius: '999px',
        padding: '10px 18px',
        fontWeight: 700,
        fontSize: '13.5px',
        fontFamily: "'Montserrat', sans-serif",
        boxShadow: '0 8px 24px rgba(43,170,94,0.35)',
        zIndex: 9999,
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.25s ease',
        minHeight: '44px',
      }}
      className="floating-wa-btn"
    >
      <img
        src="/whatsapp-1.png"
        alt="WhatsApp"
        style={{
          width: '18px',
          height: '18px',
          objectFit: 'contain',
          filter: 'brightness(0) invert(1)',
        }}
      />
      <span>WhatsApp Us</span>
    </a>
  );
};

export default FloatingWhatsApp;
